import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';

// Transform the category data returned from algolia
const transformDesignerCategory = designerData => {
    const { id, image, uri, title } = designerData;

    const heading = decodeHTMLEntities(title);

    return {
        id,
        background: image
            ? {
                  backgroundPosition: 'center center',
                  backgroundSize: 'cover',
                  title: image.alt,
                  url: image.url,
              }
            : {},
        heading,
        to: uri,
    };
};

export default transformDesignerCategory;
